import axios from 'axios'

export const getMediaFileDuration = (file) => {
  return new Promise((resolve, reject) => {
    const isUrl = typeof file === 'string'
    let url = isUrl ? file : URL.createObjectURL(file)
    let type = isUrl ? (/\.mp3|\.wav/i.test(file) ? 'audio' : 'video') : file.type
    if (type.indexOf('audio') > -1) {
      //获取时长
      let audioElement = new Audio(url)
      let duration
      audioElement.addEventListener('loadeddata', function() {
        duration = audioElement.duration
        resolve(duration)
      })

      audioElement.addEventListener('error', function(err) {
        reject(err)
      })
    }
    if (type.indexOf('video') > -1) {
      let video = document.createElement('video')
      video.style.position = 'absolute'
      video.style.left = '-9999px'
      video.src = url
      document.body.appendChild(video)
      //获取时长
      let duration
      video.addEventListener('loadeddata', function() {
        duration = video.duration
        setTimeout(() => {
          document.body.removeChild(video)
          video = null
        })
        resolve(duration)
      })
      video.addEventListener('error', function(err) {
        reject(err)
      })
    }
  })
}

export const isFileExist = url => {
  return axios.get(url, {
    timeout: 5 * 60 * 1000
  })
}
